import type express from 'express';

export function getSuffix(name: string): number {
    const INITIAL_SUFFIX = 1;
    const names = name.split('_');
    const suffix = Number(names[names.length - 1]);

    if (suffix === 0 || isNaN(suffix)) {
        return INITIAL_SUFFIX;
    }

    return suffix;
}

export function getPreffix(name: string): string {
    const names = name.split('_');
    const suffix = Number(names[names.length - 1]);

    if (!isNaN(suffix)) {
        names.pop();
        return names.join('_');
    }

    return names.join('_');
}

export function asyncHandler(
    fn: (req: express.Request, res: express.Response, next: express.NextFunction) => Promise<void>,
) {
    return (req: express.Request, res: express.Response, next: express.NextFunction) => {
        void fn(req, res, next).catch(next);
    };
}
